import { Base } from "../../framework/base";
import { ApiSuccess, IApiSuccess } from "../common/apiSuccess";
import { IInstantMessageChannelAddedUser, InstantMessageChannelAddedUser } from "./instantMessageChannelAddedUser";

export interface IInstantMessageChannelAddUsersSuccess extends IApiSuccess {
    addedUsers: IInstantMessageChannelAddedUser[];
}

export class InstantMessageChannelAddUsersSuccess extends ApiSuccess implements IInstantMessageChannelAddUsersSuccess {
    addedUsers: InstantMessageChannelAddedUser[];

    constructor();
    constructor(obj: IInstantMessageChannelAddUsersSuccess);
    constructor(obj?: any) {
        super(obj);
        this.addedUsers = Base.getTypedArray(obj ? obj.addedUsers : null, InstantMessageChannelAddedUser);
    }
}